function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.127 1.08a9.643 9.643 0 015.864 1.1 1 1 0 01.227 1.584l-4.479 4.48a.869.869 0 000 1.227l.995.995a.867.867 0 001.225 0l4.418-4.413a1 1 0 011.6.26 9.648 9.648 0 01-12.119 13.315L7.345 30.144a2.919 2.919 0 01-4.131 0l-1.357-1.358a2.92 2.92 0 010-4.13l10.523-10.518A9.646 9.646 0 0120.127 1.08zm6.632 14.964a7.648 7.648 0 001.95-7.496l-3.335 3.333a2.867 2.867 0 01-4.054 0l-.995-.996a2.869 2.869 0 010-4.055l3.443-3.444a7.643 7.643 0 00-9.3 10.55 1 1 0 01-.195 1.137L3.27 26.07a.92.92 0 000 1.3v.001l1.358 1.36a.92.92 0 001.301 0l10.995-10.997a1 1 0 011.138-.195 7.642 7.642 0 008.697-1.495z",
  fill: "currentColor"
})));